(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) ? window.Shopify.routes.root : '/';

  /* ── Helpers ── */
  function moneyFormat(cents) {
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return new Intl.NumberFormat(document.documentElement.lang === 'es' ? 'es-CL' : 'en-US', {
      style: 'currency', currency: 'CLP', maximumFractionDigits: 0
    }).format((cents || 0) / 100);
  }

  /* ── Cart drawer ── */
  function getDrawer() { return document.querySelector('[data-cart-drawer]'); }

  function setDrawerOpen(open) {
    var drawer = getDrawer();
    if (!drawer) return;
    drawer.hidden = !open;
    drawer.classList.toggle('is-open', open);
    document.documentElement.classList.toggle('pj-lock-scroll', open);
  }

  function updateCartBadges(count) {
    document.querySelectorAll('.pj-cart-badge, .pm-cart-badge').forEach(function (badge) {
      if (count > 0) {
        badge.textContent = count;
        badge.removeAttribute('data-hidden');
        badge.style.display = '';
      } else {
        badge.textContent = '';
        badge.setAttribute('data-hidden', '1');
        badge.style.display = 'none';
      }
    });
    var countEl = document.querySelector('[data-cart-drawer-count]');
    if (countEl) {
      countEl.innerHTML = count > 0
        ? '\u00a0\u00b7\u00a0' + count + ' ' + (count === 1 ? 'producto' : 'productos')
        : '';
    }
  }

  function animateCartIcon() {
    document.querySelectorAll('[data-open-cart-drawer]').forEach(function (el) {
      el.classList.remove('pj-cart-added');
      void el.offsetWidth;
      el.classList.add('pj-cart-added');
      setTimeout(function () { el.classList.remove('pj-cart-added'); }, 600);
    });
  }

  function lineItemMarkup(item) {
    var title = item.product_title || item.title || '';
    var safeTitle = title.replace(/"/g, '&quot;');
    var image = (item.featured_image && item.featured_image.url)
      ? '<a class="pj-cart-drawer-item__media" href="' + item.url + '"><img src="' + item.featured_image.url + '&width=240" alt="' + safeTitle + '"></a>'
      : '<div class="pj-cart-drawer-item__media"><div class="pj-cart-drawer-item__placeholder">Sin imagen</div></div>';
    var variant = (item.variant_title && item.variant_title !== 'Default Title')
      ? '<div class="pj-cart-drawer-item__meta">' + item.variant_title + '</div>'
      : '';
    return '<article class="pj-cart-drawer-item" data-line-key="' + item.key + '">' +
      image +
      '<div class="pj-cart-drawer-item__content">' +
        '<a class="pj-cart-drawer-item__title" href="' + item.url + '">' + title + '</a>' +
        variant +
        '<div class="pj-cart-drawer-item__price">' + moneyFormat(item.final_line_price) + '</div>' +
        '<div class="pj-cart-drawer-item__actions">' +
          '<div class="quantity-input" data-quantity-input>' +
            '<button type="button" data-cart-change data-line-key="' + item.key + '" data-quantity="' + Math.max(item.quantity - 1, 0) + '" aria-label="Restar">\u2212</button>' +
            '<input type="number" value="' + item.quantity + '" min="0" readonly>' +
            '<button type="button" data-cart-change data-line-key="' + item.key + '" data-quantity="' + (item.quantity + 1) + '" aria-label="Sumar">+</button>' +
          '</div>' +
          '<button class="pj-link-btn" type="button" data-cart-change data-line-key="' + item.key + '" data-quantity="0">Eliminar</button>' +
        '</div>' +
      '</div>' +
    '</article>';
  }

  function refreshBadge() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { updateCartBadges(cart.item_count || 0); })
      .catch(function (e) { console.error(e); });
  }

  function refreshDrawer(openAfter) {
    var drawer = getDrawer();
    if (!drawer) return;
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var total = drawer.querySelector('[data-cart-drawer-total]');
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        updateCartBadges(cart.item_count || 0);
        if (total) total.textContent = moneyFormat(cart.total_price || 0);
        var body = drawer.querySelector('.pj-cart-drawer__body');
        if (!body) return;
        if (cart.item_count > 0) {
          body.innerHTML = '<div class="pj-cart-drawer__items" data-cart-drawer-items>' + cart.items.map(lineItemMarkup).join('') + '</div>';
          if (footer) footer.hidden = false;
        } else {
          body.innerHTML = '<div class="pj-cart-drawer__empty" data-cart-drawer-empty><h3>Tu carrito est\u00e1 vac\u00edo</h3><p>Agrega productos para comenzar tu compra.</p><a class="pj-btn pj-btn--primary" href="' + root + 'collections/all">Seguir comprando</a></div>';
          if (footer) footer.hidden = true;
        }
        if (openAfter) setDrawerOpen(true);
      })
      .catch(function (e) { console.error(e); });
  }

  /* ── Upsell modal ── */
  var upsellTimer = null;
  var upsellSeconds = (window.pjUpsellSeconds && !isNaN(Number(window.pjUpsellSeconds))) ? Number(window.pjUpsellSeconds) : 10;

  function closeUpsellModal() {
    var modal = document.getElementById('pj-upsell-modal');
    if (modal) modal.hidden = true;
    document.documentElement.classList.remove('pj-lock-scroll');
    if (upsellTimer) { clearInterval(upsellTimer); upsellTimer = null; }
  }

  function goToCheckout() {
    // 1. Try the upsell checkout form (from cart drawer)
    var checkoutForm = document.querySelector('#pj-upsell-checkout-form');
    if (checkoutForm) {
      checkoutForm.submit();
      return;
    }
    // 2. Try clicking native Shopify payment button (from product page "Comprar ahora")
    var nativeBtn = document.querySelector('#pj-native-checkout [data-testid="Checkout-button"], #pj-native-checkout button, #pj-native-checkout a');
    if (nativeBtn) {
      // Temporarily show it to allow click
      var wrapper = document.getElementById('pj-native-checkout');
      if (wrapper) wrapper.style.display = '';
      nativeBtn.click();
      return;
    }
    // 3. Fallback
    window.location.href = root + 'checkout';
  }

  function startUpsellCountdown() {
    var secsEl = document.getElementById('pj-upsell-secs');
    var fillEl = document.getElementById('pj-upsell-fill');
    var secs = upsellSeconds;
    if (secsEl) secsEl.textContent = secs;
    if (fillEl) {
      fillEl.style.transition = 'none';
      fillEl.style.width = '100%';
      void fillEl.offsetWidth;
      fillEl.style.transition = 'width ' + upsellSeconds + 's linear';
      fillEl.style.width = '0%';
    }
    if (upsellTimer) { clearInterval(upsellTimer); upsellTimer = null; }
    upsellTimer = setInterval(function () {
      secs--;
      if (secsEl) secsEl.textContent = Math.max(secs, 0);
      if (secs <= 0) {
        clearInterval(upsellTimer);
        upsellTimer = null;
        closeUpsellModal();
        goToCheckout();
      }
    }, 1000);
  }

  function showUpsellModal() {
    var modal = document.getElementById('pj-upsell-modal');
    if (!modal) return;
    var productsGrid = modal.querySelector('.pj-upsell__products');
    var hasProducts = (productsGrid && productsGrid.querySelectorAll('.pj-upsell__card').length > 0);
    if (productsGrid) productsGrid.style.display = hasProducts ? '' : 'none';
    modal.hidden = false;
    document.documentElement.classList.add('pj-lock-scroll');
    startUpsellCountdown();
  }

  /* ── Global click handler ── */
  document.addEventListener('click', function (event) {
    // Quantity stepper
    var qtyButton = event.target.closest('[data-quantity-button]');
    if (qtyButton) {
      var wrapper = qtyButton.closest('[data-quantity-input]');
      if (!wrapper) return;
      var input = wrapper.querySelector('input[type="number"]');
      if (!input) return;
      var delta = Number(qtyButton.dataset.quantityButton || 0);
      var min = Number(input.getAttribute('min') || 1);
      var max = Number(input.getAttribute('max') || 9999);
      var next = Math.max(min, Math.min(max, Number(input.value || min) + delta));
      input.value = String(next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }

    // Open cart drawer
    if (event.target.closest('[data-open-cart-drawer]')) {
      event.preventDefault();
      refreshDrawer(true);
      return;
    }

    // Close cart drawer
    if (event.target.closest('[data-cart-drawer-close]')) {
      event.preventDefault();
      setDrawerOpen(false);
      return;
    }

    // Cart quantity change
    var cartChange = event.target.closest('[data-cart-change]');
    if (cartChange) {
      event.preventDefault();
      var quantity = Number(cartChange.getAttribute('data-quantity') || 0);
      var id = cartChange.getAttribute('data-line-key');
      fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: id, quantity: quantity })
      }).then(function () { refreshDrawer(true); }).catch(function (e) { console.error(e); });
      return;
    }

    // Upsell modal: close overlay
    if (event.target && event.target.id === 'pj-upsell-overlay') {
      closeUpsellModal();
      return;
    }

    // Upsell modal: close button
    if (event.target.closest('#pj-upsell-close')) {
      closeUpsellModal();
      return;
    }

    // Upsell modal: skip button
    if (event.target.closest('#pj-upsell-skip')) {
      closeUpsellModal();
      return;
    }
  });

  /* ── Submit handler ── */
  document.addEventListener('submit', function (event) {
    // 1. Add to cart (product form) — AJAX
    var productForm = event.target.closest('[data-product-form]');
    if (productForm) {
      event.preventDefault();
      var btn = productForm.querySelector('[type="submit"][name="add"]');
      if (btn && !btn.getAttribute('data-original-text')) {
        btn.setAttribute('data-original-text', btn.textContent.trim());
      }
      if (btn) { btn.disabled = true; btn.textContent = '\u2713 Agregado'; }

      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: new FormData(productForm)
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart add failed');
        return r.json();
      })
      .then(function () {
        refreshBadge();
        animateCartIcon();
        if (btn) {
          setTimeout(function () {
            btn.disabled = false;
            btn.textContent = btn.getAttribute('data-original-text') || 'Agregar al carrito';
          }, 1500);
        }
        // No upsell on add-to-cart — only on checkout intent
      })
      .catch(function (e) {
        console.error(e);
        if (btn) { btn.disabled = false; btn.textContent = btn.getAttribute('data-original-text') || 'Agregar al carrito'; }
        productForm.submit();
      });
      return;
    }

    // 2. Upsell add product — AJAX, then reset countdown
    var upsellForm = event.target.closest('[data-product-upsell]');
    if (upsellForm) {
      event.preventDefault();
      var addBtn = upsellForm.querySelector('.pj-upsell__add-btn');
      if (addBtn) { addBtn.disabled = true; addBtn.textContent = '\u2713'; }
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
        body: new FormData(upsellForm)
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        refreshBadge();
        if (addBtn) { addBtn.textContent = '\u2713 Agregado'; }
        // Reset countdown after adding upsell product
        startUpsellCountdown();
      })
      .catch(function () {
        if (addBtn) { addBtn.disabled = false; addBtn.textContent = '+ Agregar'; }
      });
      return;
    }

    // 3. Checkout forms (cart drawer, upsell modal) — let submit natively
    // Do NOT intercept these
  });

  /* ── Checkout intent: show upsell before going to checkout ── */
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('[data-trigger-upsell]');
    if (!trigger) return;
    // Only intercept if modal exists and is hidden
    var modal = document.getElementById('pj-upsell-modal');
    if (!modal || !modal.hidden) return;
    event.preventDefault();
    showUpsellModal();
  });

  /* ── Init ── */
  refreshBadge();
})();
